import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import logo from '../../assets/images/The-Key-Logo.png';
import apiClient from "../../utils/api";

function ParkingKeyTicket() {
  const { id } = useParams();
  const [parking, setParking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ticketRef = useRef(null);

  // Fetch parking data using the ID from URL params
  useEffect(() => {
    const fetchParkingData = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        const token = localStorage.getItem('auth_token');
        const response = await apiClient.get(`accounts/parkings/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log('API response:', response.data.data);
        setParking(response.data.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching parking data:', err);
        setError('Failed to fetch parking data');
        setLoading(false);
      }
    };
    fetchParkingData();
  }, [id]);

  useEffect(() => {
    if (!parking) return;
    
    console.log('Printing ticket:', parking);
    // Add a small delay to ensure the component is fully rendered
    setTimeout(() => {
      printTicket();
    }, 500);
  }, [parking]); // Re-run when parking data changes

  const printTicket = async () => {
    if (!parking) return;

    // Extract ticket data
    const {
      ticket_number: serial = '',
      plate_number: plate = '',
      model = null,
      color = null,
      parking_time = '',
      parking_date = '',
      parking_type = ''
    } = parking;

    const modelName = model?.name || 'N/A';
    const colorName = color?.name || 'N/A';
    const parkingTypeDisplay = parking_type === 'Complementary' ? 'FREE' : (parking_type || 'Normal');
    const plateDisplay = plate || 'N/A';
    const parkingDateTime = parking_time && parking_date ? 
      `${new Date(parking_date).toLocaleDateString()} ${parking_time}` : 'N/A';
    const serialDisplay = serial || 'N/A';

    // Create ticket content for thermal printer
    const ticketContent = `
${'-'.repeat(32)}
     THE KEY VALET SERVICES
${'-'.repeat(32)}
Ticket No: ${serialDisplay}
${parkingTypeDisplay}
${'-'.repeat(32)}
Plate No.     : ${plateDisplay}
Car Model     : ${modelName}
Color         : ${colorName}
Parking Time  : ${parkingDateTime}
${'-'.repeat(32)}
`;

    // Detect user agent for appropriate printing method
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = userAgent.indexOf("android") > -1;
    
    if (isAndroid) {
      // Use Intent scheme for Android devices
      androidPrint(ticketContent);
    } else {
      // Use WebSocket for desktop/PC
      desktopPrint(ticketContent);
    }
  };

  const androidPrint = (data) => {
    try {
      const beforeUrl = 'intent:';
      const afterUrl = '#Intent;scheme=rawbt;package=ru.a402d.rawbtprinter;end;';
      const textEncoded = encodeURI(data);
      window.location.href = beforeUrl + textEncoded + afterUrl;
      console.log('Ticket sent to Android RawBT app via intent scheme');
    } catch (error) {
      console.error('Error sending to Android RawBT app:', error);
    }
  };

  const desktopPrint = (data) => {
    try {
      // Create WebSocket connection to local print server
      const ws = new WebSocket('ws://localhost:3000');
      
      ws.onopen = () => {
        ws.send(data);
        console.log('Ticket sent to printer via WebSocket');
      };

      ws.onerror = (error) => {
        console.error('WebSocket error:', error);
      };

      ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    } catch (error) {
      console.error('Error connecting to print server:', error);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!parking) return <div>No parking data available</div>;

  // Extract ticket data
  const {
    ticket_number: serial = '',
    plate_number: plate = '',
    model = null,
    color = null,
    parking_time = '',
    parking_date = '',
    parking_type = ''
  } = parking;

  const modelName = model?.name || 'N/A';
  const colorName = color?.name || 'N/A';
  const parkingTypeDisplay = parking_type === 'Complementary' ? 'FREE' : (parking_type || 'Normal');
  const plateDisplay = plate || 'N/A';
  const parkingDateTime = parking_time && parking_date ? 
    `${new Date(parking_date).toLocaleDateString()} ${parking_time}` : 'N/A';
  const serialDisplay = serial || 'N/A';

  return (
    <div className="print-ticket-container" ref={ticketRef}>
      <style>
        {`
        @page {
          margin: 0;
          size: 80mm auto;
        }
        .print-ticket-container {
          width: 72mm;
          padding: 1mm;
          font-family: Arial, sans-serif;
          color: #333;
          text-align: center;
        }
        .ticket-header {
          text-align: center;
          margin-bottom: 1mm;
        }
        .ticket-logo {
          width: 25mm;
          margin-bottom: 1mm;
        }
        .ticket-details {
          width: 100%;
          margin: 2mm 0;
          border-collapse: collapse;
        }
        .ticket-details td {
          padding: 1mm;
          font-size: 3.5mm;
          text-align: left;
        }
        .ticket-divider {
          margin: 2mm 0;
          border: none;
          border-top: 1px dashed #000;
        }
        .ticket-serial {
          margin: 1mm 0;
          text-align: left;
          padding-left: 1mm;
          font-size: 4mm;
        }
        .parking-type {
          text-align: left;
          padding-left: 1mm;
          font-size: 3.5mm;
          color: #967c3d;
        }
        @media print {
          body { margin: 0; padding: 0; }
          .print-ticket-container { 
            width: 72mm;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
        `}
      </style>

      <div className="ticket-header">
        <img src={logo} alt="Key Valet" className="ticket-logo" />
      </div>

      <hr className="ticket-divider" />
      <div className="ticket-title">THE KEY VALET SERVICES</div>
      <hr className="ticket-divider" />

      <div className="ticket-serial">
        Ticket No: {serialDisplay}
      </div>
      <div className="parking-type">{parkingTypeDisplay}</div>

      <hr className="ticket-divider" />

      <table className="ticket-details">
        <tbody>
          <tr>
            <td>Plate No.</td>
            <td>: {plateDisplay}</td>
          </tr>
          <tr>
            <td>Car Model</td>
            <td>: {modelName}</td>
          </tr>
          <tr>
            <td>Color</td>
            <td>: {colorName}</td>
          </tr>
          <tr>
            <td>Parking Time</td>
            <td>: {parkingDateTime}</td>
          </tr>
        </tbody>
      </table>

      <hr className="ticket-divider" />
    </div>
  );
}

export default ParkingKeyTicket;
